import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, TOKENS) => ({
    ...TOKENS,
    container: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_100,
        align_items: 'flex-start',
        ...TOKENS.container,
    },
    typography: {
        font_weight: FONT_WEIGHT.font_regular,
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        color: FOUNDATIONS.color_feedback_error_font_50,
        ...TOKENS.typography,
    },
    icon: {
        width: FOUNDATIONS.size_250,
        height: FOUNDATIONS.size_250,
        ...TOKENS.icon,
    },
});
//# sourceMappingURL=commonStyles.js.map